var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('resource-overview',{ref:"resOverview",attrs:{"resource-type":'audio',"cates":_vm.cates,"rank-data":_vm.rankData,"rec-data":_vm.recData,"latest-data":_vm.latestData,"pull-up-handler":_vm.pullUpHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }